<template>
  <div class="flex flex-col space-y-6 component-layout relative min-h-[75vh]">
    <VLoading 
      v-if="isLoading" 
      class="absolute inset-0 bg-white/80 z-40" 
      :loading-text="t('general.loading')" 
      :show-loading-text="true"
    />

    <!-- OAuth Loading Overlay -->
    <OAuthLoadingOverlay 
      :is-visible="showOAuthLoading"
      :platform-id="currentPlatformId"
      :status="oauthStatus"
      :error-message="oauthErrorMessage"
    />

    <div class="bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="p-4 border-b border-gray-100">
        <h2 class="text-lg font-semibold text-gray-800">{{ t('settings.components.integrations.title') }}</h2>
        <p class="text-sm text-gray-500">{{ t('settings.components.integrations.description') }}</p>
      </div>

      <IntegrationList 
        :integrations="sortedIntegrations"
        @toggle="toggleIntegration"
        @manage="openManageModal"
      />
    </div>

    <!-- Modals -->
    <!-- IntegrationManageModal removed -->

    <GoogleStatusModal 
      :modelValue="showGoogleStatusModal"
      @update:modelValue="showGoogleStatusModal = $event"
      :is-loading="isLoading"
    />
  </div>
</template>

<script setup>
import { onMounted, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import VLoading from '@/components/loading/VLoading.vue'
import IntegrationList from './components/IntegrationList.vue'
// IntegrationManageModal import removed
import GoogleStatusModal from './components/modals/GoogleStatusModal.vue'
import OAuthLoadingOverlay from './components/OAuthLoadingOverlay.vue'

// Composables
import { useIntegrationManagement } from './composables'

const { t, locale } = useI18n()

// Get state and methods from composables
const {
  // State
  integrations,
  // showManageModal removed
  showGoogleStatusModal,
  // selectedIntegration removed
  isLoading,
  sortedIntegrations,
  showOAuthLoading,
  currentPlatformId,
  oauthStatus,
  oauthErrorMessage,
  
  // Methods
  toggleIntegration,
  openManageModal,
  checkAuth,
  checkPendingIntegration
} = useIntegrationManagement()

// Watchers - handled in composable now
// watch for other changes if needed

// Lifecycle hooks
onMounted(() => {
  integrations.value.forEach((integration) => {
    integration.loading = true
  })

  // Initialize integrations
  checkAuth()
  checkPendingIntegration()
})
</script>
